module.exports = __webpack_public_path__ + "static/img/vipbanner.dc45d918.png";